import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@hilbi/web-common/components/e-visits/button';
import Modal from '@components/modal';
import { getTimeFormat } from '../../../../../../helpers/utils-helpers';
import { TExistingEVisitRule } from 'types/e-visits';
import { DeleteTypeModalSC } from './delete-type-modal.styled';

interface DeleteTypeModalProps {
  visible: boolean;
  event?: TExistingEVisitRule;
  setVisible: () => void;
  onSuccess: (type: 'all' | 'current') => void;
  deleteRepeatingEvent: boolean;
}

const DeleteTypeModal: React.FunctionComponent<DeleteTypeModalProps> = ({
  visible,
  setVisible,
  onSuccess,
  event,
  deleteRepeatingEvent,
}) => {
  const start = event?.fromTime ? moment(event.fromTime) : undefined;
  const end = event?.toTime ? moment(event.toTime) : undefined;
  const timeFormat = getTimeFormat(false);

  return (
    <Modal isOpen={visible} showClose onRequestClose={() => setVisible()} zIndex={100000}>
      <DeleteTypeModalSC>
        <div className="title">
          <FormattedMessage
            id={deleteRepeatingEvent ? 'deleteTypeModal_title_repeating' : 'deleteTypeModal_title'}
          />
        </div>
        <div className="event-info">
          {start?.format('dddd')}
          <span className="time">
            {start?.format(timeFormat)} - {end?.format(timeFormat)}
          </span>
        </div>
        {deleteRepeatingEvent ? (
          <div className="sub-title">
            <FormattedMessage id="deleteTypeModal_subtitle" />
          </div>
        ) : null}
        <div className="actions-wrapper">
          {deleteRepeatingEvent ? (
            <>
              <Button
                variation={'warn'}
                isBlock
                type="button"
                onClick={() => {
                  onSuccess('current');
                }}
              >
                <FormattedMessage id="deleteTypeModal_current" />
              </Button>
              <Button
                variation={'warn'}
                isBlock
                type="button"
                onClick={() => {
                  onSuccess('all');
                }}
              >
                <FormattedMessage id="deleteTypeModal_all" />
              </Button>
            </>
          ) : (
            <Button
              className={'single-delete-button'}
              variation={'warn'}
              isBlock
              type="button"
              onClick={() => {
                onSuccess('all');
              }}
            >
              <FormattedMessage id="deleteTypeModal_delete_event" />
            </Button>
          )}
        </div>
      </DeleteTypeModalSC>
    </Modal>
  );
};

export default React.memo(DeleteTypeModal);
